import "highcharts/modules/drilldown";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export const VehicleReportView = ({ data,isLoading }: any) => {
  const report = data?.res || data; // support both data and data.res

  if (!report || !report.categoriesJson?.length || !report.chartSeries?.length) {
     return !isLoading?(<div>No Data Found</div>):(<div>Loading chart...</div>);
  }
  const options: Highcharts.Options = {
      chart: {type: 'line',},
      title: {  text: 'Vehicle Entry Exit',},
      subtitle: {  useHTML: true, },
      xAxis: { categories:report.categoriesJson || [] ,
      title: {  text: '',},
      },
      yAxis: {  title: { text: 'Vehicle Entry Exit', }, labels: {
          formatter: function () {
            return `${this.value as number}`;
          }
        }},
         tooltip: {
        formatter: function () {
          return `${this.y as number}`;
        }
      },
     plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y as number;
            }
          }
        }
      },
      credits: {
    enabled: false
  },
      series:report.chartSeries || [] ,
};
        

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
